import { graphql } from "../gql";

export const getAgentQueryDoc = graphql(`
  query getAgent($id: ID!) {
    agent(id: $id) {
      ...AgentFragment
      messages {
        ...AgentMessageFragment
      }
      recommendation {
        ...AgentRecommendationFragment
      }
    }
  }
`);
